import React, { useState } from 'react'

import { useAppSelector } from 'redux/hooks'

import PhatButton from 'components/formElements/PhatButton'

// TODO - refactor this ffs
import Search from './buttons/Search'
import Import from './buttons/Import'
import ImportFromPrecon from './buttons/ImportFromPrecon'

import styles from './emptyDeckLanding.module.scss'

type Props = { ownsDeck: boolean }

const NewDeckView = ({ ownsDeck }: Props) => {
  const sandbox = useAppSelector(state => !state.deck.id)
  const hasCards = useAppSelector(state => !!Object.keys(state.deck.cardMap).length)

  // Once the new deck view is closed, this prevents it from ever coming back (without a reload)
  const [closed, setClosed] = useState(hasCards)

  if (hasCards || closed) return null

  return (
    <div className={styles.container}>
      {ownsDeck && (
        <div className={styles.options}>
          <div className={styles.row}>
            <Search />
            <Import />
            <ImportFromPrecon />
          </div>
          <div className={styles.row}>
            <PhatButton onClick={() => setClosed(true)} color="orange">
              Close new deck helper
            </PhatButton>
          </div>
        </div>
      )}

      {sandbox && (
        <div className={styles.sandboxWarning}>
          <p>
            Keep in mind that you're in the sandbox. Anything done here won't save unless you have an account and create
            a deck.
          </p>
        </div>
      )}
      {!ownsDeck && <h3 className={styles.message}>You are viewing an empty deck.</h3>}
    </div>
  )
}

export default NewDeckView
